module.exports = __webpack_public_path__ + "img/slide_bg.b1b47488.png";